import { CarouselLayout, GenericCarouselLayout } from '../../common';
import { ImgQuery } from '../services';

export const getImgQueryByCarouselLayout = (layout: CarouselLayout | GenericCarouselLayout): ImgQuery => {
  switch (layout) {
    case CarouselLayout.LandscapeSmall:
      return {
        XS: 91,
        SM: 171,
        MD: 229,
        LG: 302,
        XL: 302,
      };
    case CarouselLayout.LandscapeLarge:
      return {
        XS: 140,
        SM: 171,
        MD: 229,
        LG: 302,
        XL: 302,
      };
    case GenericCarouselLayout.Large:
    case GenericCarouselLayout.Small:
      return {
        XS: 91,
        SM: 171,
        MD: 229,
        LG: 196,
        XL: 281,
      };
    case CarouselLayout.PortraitSmall:
      return {
        XS: 91,
        SM: 111,
        MD: 150,
        LG: 143,
        XL: 207,
      };
    case CarouselLayout.PortraitLarge:
    case CarouselLayout.PortraitTop10:
      return {
        XS: 91,
        SM: 171,
        MD: 150,
        LG: 196,
        XL: 281,
      };
    case GenericCarouselLayout.Medium:
      return {
        XS: 140,
        SM: 171,
        MD: 229,
        LG: 302,
        XL: 430,
      };
  }
};
